/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoItemRequest model module.
 * @module model/PerplayStatisticsControllerDtoItemRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoItemRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoItemRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoItemRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoItemRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoItemRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoItemRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoItemRequest} The populated <code>PerplayStatisticsControllerDtoItemRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoItemRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = ApiClient.convertToType(data['itemType'], 'String');
            }
            if (data.hasOwnProperty('gemType')) {
                obj['gemType'] = ApiClient.convertToType(data['gemType'], 'String');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'String');
            }
            if (data.hasOwnProperty('isGem')) {
                obj['isGem'] = ApiClient.convertToType(data['isGem'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoItemRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoItemRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoItemRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['itemType'] && !(typeof data['itemType'] === 'string' || data['itemType'] instanceof String)) {
            throw new Error("Expected the field `itemType` to be a primitive type in the JSON string but got " + data['itemType']);
        }
        // ensure the json data is a string
        if (data['gemType'] && !(typeof data['gemType'] === 'string' || data['gemType'] instanceof String)) {
            throw new Error("Expected the field `gemType` to be a primitive type in the JSON string but got " + data['gemType']);
        }
        // ensure the json data is a string
        if (data['level'] && !(typeof data['level'] === 'string' || data['level'] instanceof String)) {
            throw new Error("Expected the field `level` to be a primitive type in the JSON string but got " + data['level']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoItemRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoItemRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoItemRequest.prototype['endDate'] = undefined;

/**
 * @member {String} itemType
 */
PerplayStatisticsControllerDtoItemRequest.prototype['itemType'] = undefined;

/**
 * @member {String} gemType
 */
PerplayStatisticsControllerDtoItemRequest.prototype['gemType'] = undefined;

/**
 * @member {String} level
 */
PerplayStatisticsControllerDtoItemRequest.prototype['level'] = undefined;

/**
 * @member {Boolean} isGem
 */
PerplayStatisticsControllerDtoItemRequest.prototype['isGem'] = undefined;






export default PerplayStatisticsControllerDtoItemRequest;

